import { slicedToArray as _slicedToArray } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useRef, useState, useEffect } from 'react';
import { PACKAGE_CARD } from '../../utils/dataTrackingValues.js';
import customTheme from '../../utils/theme.js';
import { PackageCardWrapper } from './PackageCard.styles.js';
import HorizontalPackageCard from './HorizontalPackageCard/HorizontalPackageCard.js';
import DefaultPackageCard from './DefaultPackageCard/DefaultPackageCard.js';

var PackageCard = function PackageCard(_ref) {
  var _Theme$components;
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$content = _ref.content,
    content = _ref$content === void 0 ? null : _ref$content,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? null : _ref$image,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? 'Default' : _ref$layout,
    _ref$mobileCarousel = _ref.mobileCarousel,
    mobileCarousel = _ref$mobileCarousel === void 0 ? false : _ref$mobileCarousel,
    _ref$modal = _ref.modal,
    modal = _ref$modal === void 0 ? null : _ref$modal,
    packageData = _ref.packageData,
    _ref$requestId = _ref.requestId,
    requestId = _ref$requestId === void 0 ? null : _ref$requestId;
  var labelRef = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  var labelData = {
    inside: customTheme === null || customTheme === void 0 || (_Theme$components = customTheme.components) === null || _Theme$components === void 0 || (_Theme$components = _Theme$components.PackageCard) === null || _Theme$components === void 0 || (_Theme$components = _Theme$components.label) === null || _Theme$components === void 0 ? void 0 : _Theme$components.inside,
    type: packageData !== null && packageData !== void 0 && packageData.labelOffer ? 'brandyLabel' : 'contentfulLabel',
    text: (packageData === null || packageData === void 0 ? void 0 : packageData.labelOffer) || label
  };
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    mounted = _useState4[0],
    setMounted = _useState4[1];
  useEffect(function () {
    setMounted(true);
  }, []);
  useEffect(function () {
    if (mounted && labelRef.current) {
      setHeight(labelRef.current.offsetHeight);
    }
  }, [mounted]);
  return /*#__PURE__*/React__default.createElement(PackageCardWrapper, {
    className: "leshen-package-card",
    layout: layout,
    height: height,
    labelType: labelData.type,
    extraTopSpacingForLabel: labelData === null || labelData === void 0 ? void 0 : labelData.text,
    mobileCarousel: mobileCarousel,
    onClick: function onClick() {
      return PACKAGE_CARD.handleClick(packageData.name, requestId);
    }
  }, layout === 'Horizontal' ? /*#__PURE__*/React__default.createElement(HorizontalPackageCard, {
    labelData: labelData,
    packageData: packageData,
    height: height,
    modal: modal,
    content: content,
    requestId: requestId,
    mobileCarousel: mobileCarousel,
    layout: layout,
    image: image
  }, children) : /*#__PURE__*/React__default.createElement(DefaultPackageCard, {
    labelData: labelData,
    labelRef: labelRef,
    packageData: packageData,
    height: height,
    modal: modal,
    content: content,
    requestId: requestId,
    mobileCarousel: mobileCarousel,
    layout: layout
  }, children));
};
var PackageCard$1 = PackageCard;

export { PackageCard$1 as default };
//# sourceMappingURL=index.js.map
